import { createContext } from "react";

const BannerContext = createContext();

export default BannerContext;